import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { Edit } from "react-feather";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  AutoComplete,
  Button,
  FormFeedback,
} from "reactstrap";
import { useFormik } from "formik";
import Notiflix, { Report } from "notiflix";
import GetApiCall from "../Api/GetApi";
import PostApiCall from "../Api/Api";
import BreadCrumb from "../Components/BreadCrumbComp";
import { Folder, XSquare, FileText } from "react-feather";
import ResumeBuilderModal from "./ResumeBuilderModal";
import maleIcon from "../assets/profile/user.jpeg";

import femaleIcon from "../assets/profile/female-icon.png";
import { useNavigate } from "react-router-dom";
// import { ImageApiUrl, PdfApiUrl } from "../Helper/Additional";
import moment from "moment/moment";
import { delay } from "../Helper/ToastDelay";
import { SomethingWrong } from "../Helper/ErrorMessages";
import { useDispatch, useSelector } from "react-redux";

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_orange.css";

import {
  fileConverterHandler,
  imageConverterHandler,
} from "../Helper/Converter";
import {
  addressProof,
  Allqualification,
  basicSchemaPartOne,
  basicSchemaPartTwo,
  gender,
  idProof,
  usertype,
  validationSchema,
} from "../Pages/Profile/helper";
import { maskDocumentNumber } from "../Pages/Auditor/helper";
import { generateCustomStyles } from "../Helper/CustomStyleError";
import { ProfileAction } from "../Store/Actions/ProfileAction";

const getFileUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http") || path.startsWith("blob:")) return path;
  return (process.env.REACT_APP_FILE_PATH_URL || "") + path;
};

const BasicProfileContent = ({ userData, setProfileModal }) => {
  const history = useNavigate();
  const [allCountry, setAllCountry] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allCity, setAllCity] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const dispatch = useDispatch();

  const [imageUrl, setImageUrl] = useState("");
  const [step, setStep] = useState(1); // Step state
  const [showResumeModal, setShowResumeModal] = useState(false);

  const handleNext = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length === 0) {
      setStep(step + 1); // Proceed only if no validation errors
    } else {
      console.log("err",errors)
      formik.setTouched(errors); // Show errors on fields
    }
  };

  const handlePrevious = () => setStep(step - 1);
  const formik = useFormik({
    initialValues: {
      PhotoFile: userData.fld_photo,
      AuditorName: userData.fld_name,
      AuditorAge: userData?.fld_dob
        ? moment(userData?.fld_dob.split("T")[0], "YYYY/MM/DD").format(
          "YYYY-MM-DD"
        )
        : "",

      AuditorContact: userData.fld_mobile,
      AuditorGmail: userData.fld_email,
      OnBoardStatus: userData?.fld_onboardstatus
        ? {
          label: userData.fld_onboardstatus,
          value: userData.fld_onboardstatus,
        }
        : { value: "Pending", label: "Pending" },
      gender:
        userData?.fld_gender !== null && userData?.fld_gender !== ""
          ? { label: userData.fld_gender, value: userData.fld_gender }
          : "",
      AuditorAddress: userData.fld_presentaddress,
      AuditorCity: userData?.fld_presentcity
        ? { label: userData.fld_presentcity, value: userData.fld_presentcity }
        : "",
      AuditorCountry: userData?.fld_presentcountry
        ? {
          label: userData.fld_presentcountry,
          value: userData.fld_presentcountry,
        }
        : { value: 101, label: "India" },
      AuditorState: userData?.fld_presentstate
        ? { label: userData.fld_presentstate, value: userData.fld_presentstate }
        : "",
      AuditorPincode: userData.fld_presentpincode,
      AuditorQual:
        userData?.fld_qualification !== null &&
          userData?.fld_qualification !== ""
          ? {
            label: userData.fld_qualification,
            value: userData.fld_qualification,
          }
          : "",
      TotalExperience: userData.fld_experience,
      ExperienceTrpw: 1,
      WorkExperience: userData.fld_worksummary,
      IDProof: {
        label: userData.fld_identityprooftype,
        value: userData.fld_identityprooftype,
      },
      IdProofNumber: userData.fld_identityproofnumber,
      AddressProof: {
        label: userData.fld_addressprooftype,
        value: userData.fld_addressprooftype,
      },
      AddressProofNumber: userData.fld_addressproofnumber,
      qualProofFile: "",
      identityProofFile: "",
      AddressProofFile: "",

      usertype: {
        label: userData.fld_usertype,
        value: userData.fld_usertype,
      },
      PreEmployeeName: "",
      SourceName: userData.fld_sourcename,
      WorkCity:
        userData.work_preference !== null || userData.work_preference !== ""
          ? userData.work_preference
            ?.split(",")
            .map((value) => ({ label: value, value: value }))
          : [],

      resumeFile: userData?.fld_resumeurl ?? "",
      verifydoc: userData.fld_verifydoc,
    },
    validateOnChange: true,
    validationSchema: step === 1 ? basicSchemaPartOne : basicSchemaPartTwo,
    onSubmit: async (values) => {
      if (step === 1) {
        const valid = await formik.validateForm();
        if (Object.keys(valid).length === 0) {
          setStep(step + 1);
        }
        return;
      }

      try {
        Notiflix.Loading.standard();

        const UserUpdate = {
          id: userData.fld_id[0],
          name: values.AuditorName,
          mobile: values.AuditorContact,
          email: values.AuditorGmail,
          usertype: values.usertype.value,
          updatedon: moment().format("ll"),
          profileflag: 1,
          onboardstatus: formik.values.OnBoardStatus.value || "Pending",
        };

        const payload = {
          id: userData.fld_id[1],
          photo: values.PhotoFile,
          employeeid: userData.fld_employeeid,
          dob: values.AuditorAge,
          gender: values.gender.value,
          presentaddress: values.AuditorAddress,
          presentcountry: values.AuditorCountry.label,
          presentstate: values.AuditorState.label,
          presentcity: values.AuditorCity.label,
          presentpincode: values.AuditorPincode,
          permanentaddress: "456 Park St",
          permanentcountry: "Country2",
          permanentstate: "State2",
          permanentcity: "City2",
          permanentpincode: "67890",
          qualification: values.AuditorQual.value,
          experience: values.TotalExperience,
          expowncompany: values.ExperienceTrpw || 0,
          worksummary: values.WorkExperience,
          identityprooftype: values.IDProof.value,
          identityproofname: values.PanHolderName || "",
          identityproofnumber: values.IdProofNumber,
          addressprooftype: values.AddressProof.value,
          addressproofnumber: values.AddressProofNumber,
          identityproofurl: userData.fld_identityproofurl,
          addressproofurl: userData.fld_addressproofurl,
          qualificationproofurl: userData.fld_qualificationproofurl,
          resumeurl: userData.fld_resumeurl,
          userid: userData.fld_id[0],
          sourcename: values.SourceName,
          verifyaccount: 1,
          fld_verifydoc: 0,
          prevcompname: values.PreEmployeeName || "",
          fld_verifyemp: 0
        };

        let cityArr =
          values?.WorkCity !== undefined
            ? values.WorkCity.map((ele) => ele.value.trim()).join(",")
            : "";
        payload.workcity = cityArr;

        const registerCandidateResult = await PostApiCall.postRequest(
          UserUpdate,
          "UpdateJobUsers"
        );

        if (registerCandidateResult.status === 200) {
          const promises = [];
          if (
            formik.values.resumeFile &&
            typeof formik.values.resumeFile === "object"
          ) {
            promises.resumePromise = fileConverterHandler(
              formik.values.resumeFile,
              userData.fld_id[0],
              "Resume"
            );
          }

          if (
            formik.values.PhotoFile &&
            typeof formik.values.PhotoFile === "object"
          ) {
            promises.photoPromise = imageConverterHandler(
              formik.values.PhotoFile,
              userData.fld_id[0],
              "Profile"
            );
          }
          const results = await Promise.allSettled(Object.values(promises));
          // Assign results to the corresponding payload keys
          Object.keys(promises).forEach((promiseKey, index) => {
            const result = results[index];
            if (result.status === "fulfilled") {
              switch (promiseKey) {
                case "resumePromise":
                  payload.resumeurl = result.value;
                  break;
                case "photoPromise":
                  payload.photo = result.value;
                  break;
                default:
                  break;
              }
            }
          });
          let addJobAuditorResult;
          if (userData.fld_id[1] !== null) {
            addJobAuditorResult = await PostApiCall.postRequest(
              payload,
              "UpdateJobAuditor"
            );
          } else {
            addJobAuditorResult = await PostApiCall.postRequest(
              payload,
              "AddJobAuditor"
            );
          }

          if (
            addJobAuditorResult.status === 200 ||
            addJobAuditorResult.status === 201
          ) {
            Notiflix.Loading.remove();
            Report.success(
              "Thanks for completing the registration!",
              "Our team will get back to you.\n\nTo speed up your onboarding process, please complete your profile."
            );
          } else {
            const errorMessage = await addJobAuditorResult.json();
            Notiflix.Loading.remove();
            toast.error(errorMessage.data, { autoClose: delay, toastId: 1 });
          }
        } else {
          const errorMessage = await registerCandidateResult.json();
          Notiflix.Loading.remove();
          toast.error(errorMessage.data, { autoClose: delay, toastId: 1 });
        }
      } catch (error) {
        toast.error("Something went wrong", { autoClose: delay, toastId: 1 });
        Notiflix.Loading.remove();
      }

      setProfileModal(false);
      dispatch(ProfileAction.GetSeekerDetails());
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    const getCountry = () => {
      GetApiCall.getRequest("GetCountry").then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllCountry(obj?.data);
          // Notiflix.Loading.remove()
        })
      );
    };
    getCountry();
  }, [formik.values.AuditorCountry.value]);

  useEffect(() => {
    const getState = () => {
      const filterState = allCountry?.find(
        (i) => i.label == formik.values?.AuditorCountry?.label
      );
      PostApiCall.postRequest(
        { countryid: filterState?.value },
        "GetState"
      ).then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllState(obj?.data);
          // formik.setFieldValue("AuditorState", obj?.data[0]);
          const currentState = obj?.data?.find(
            (state) => state?.label === formik.values?.AuditorState?.label
          );
          // formik.setFieldValue("AuditorState", currentState);
          // Notiflix.Loading.remove()
        })
      );
    };
    getState();
  }, [formik.values.AuditorCountry, allCountry]);
  useEffect(() => {
    const getCity = () => {
      const filterCity = allState?.find(
        (i) => i?.label == formik.values?.AuditorState?.label
      );
      PostApiCall.postRequest({ stateid: filterCity?.value }, "GetCity").then(
        (resultdes) =>
          resultdes.json().then((obj) => {
            const cities = obj?.data || [];
            setAllCity(cities);

            if (cities.length < 0) {
              formik.setFieldValue("AuditorCity", {
                value: "none",
                label: "None",
              });
            }
            // Notiflix.Loading.remove()
          })
      );
    };
    getCity();
  }, [formik.values.AuditorState, allState]);

  const handleRemoveImage = () => {
    setImageUrl("");
  };

  return (
    <div className="auditorApp">
      <FormGroup className="">
        <Card
          id="jobCard "
          className="border-0"
        // style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          <CardBody>
            {step == 1 && (
              <Row>
                <Col sm={"12"}>
                  <div className="d-flex flex-wrap align-items-center">
                    <div className="avatar avatar-xl mb-4">
                      <img
                        src={
                          imageUrl
                            ? imageUrl
                            : process.env.REACT_APP_FILE_PATH_URL +
                            userData.fld_photo
                        }
                        alt="User Image"
                        width={"100%"}
                        height={"100%"}
                        className="shadow"
                        onError={(e) => (e.target.src = maleIcon)}
                      />
                    </div>

                    <FormGroup className="ml-2">
                      <div className="ml-md-3 mb-4">
                        <em>(Only *.jpeg and *.png images will be accepted)</em>
                        <br />
                        <label
                          htmlFor="imgUpload"
                          color="primary"
                          outline={true}
                          className="btn-border ml-2 mt-3 px-2 "
                        >
                          Upload Profile Image
                        </label>
                        {formik.touched.PhotoFile && formik.errors.PhotoFile && (
                          <FormFeedback className="d-block ml-2">
                            {formik.errors.PhotoFile}
                          </FormFeedback>
                        )}

                        <input
                          style={{ display: "none" }}
                          type="file"
                          accept="image/*"
                          id={"imgUpload"}
                          capture
                          onChange={(e) => {
                            e.preventDefault();
                            const file = e.target.files[0];
                            setImageUrl(URL.createObjectURL(file));

                            formik.setFieldValue("PhotoFile", file);
                            if (file && file.size > 5000000) {
                              Notiflix.Notify.failure(
                                "File too large, upload file less than 5 Mb."
                              );
                            }
                          }}
                        />
                        {imageUrl && (
                          <XSquare
                            size={30}
                            className="text-danger"
                            onClick={handleRemoveImage}
                          />
                        )}
                      </div>

                    </FormGroup>
                  </div>
                  {/* {formik.touched.PhotoFile &&
                      formik.errors.PhotoFile && (
                        <FormFeedback>{formik.errors.PhotoFile}</FormFeedback>
                      )} */}
                </Col>
                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Full Name<span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="AuditorName"
                      id="nameVertical"
                      placeholder="Enter your name"
                      style={{ textTransform: "capitalize" }}
                      onChange={formik.handleChange}
                      value={formik.values.AuditorName}
                      invalid={
                        formik.touched.AuditorName &&
                        !!formik.errors.AuditorName
                      }
                    />
                    {formik.touched.AuditorName &&
                      formik.errors.AuditorName && (
                        <FormFeedback>{formik.errors.AuditorName}</FormFeedback>
                      )}
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Email Address<span className="mandatory">*</span>
                    </Label>
                    <Input
                      disabled
                      type="text"
                      name="AuditorGmail"
                      id="nameVertical"
                      placeholder="Enter your email"
                      onChange={formik.handleChange}
                      value={formik.values.AuditorGmail}
                      invalid={
                        formik.touched.AuditorGmail &&
                        !!formik.errors.AuditorGmail
                      }
                    />
                    {formik.touched.AuditorGmail &&
                      formik.errors.AuditorGmail && (
                        <FormFeedback>
                          {formik.errors.AuditorGmail}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="">
                      Contact Number<span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="AuditorContact"
                      id="nameVertical"
                      placeholder="Enter your Contact"
                      maxLength={10}
                      onChange={formik.handleChange}
                      value={formik.values.AuditorContact}
                      invalid={
                        formik.touched.AuditorContact &&
                        !!formik.errors.AuditorContact
                      }
                    />
                    {formik.touched.AuditorContact &&
                      formik.errors.AuditorContact && (
                        <FormFeedback>
                          {formik.errors.AuditorContact}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>

                <Col style={{ zIndex: "4" }}>
                  <FormGroup>
                    <Label htmlFor="">
                      Gender<span className="mandatory">*</span>
                    </Label>
                    <Select
                      classNamePrefix="select"
                      name="gender"
                      onChange={(selectedOption) => {
                        formik.setFieldValue("gender", selectedOption);
                      }}
                      options={gender}
                      value={formik.values.gender}
                      className={`React ${formik.touched.gender && formik.errors.gender
                          ? "is-invalid"
                          : ""
                        }`}
                      styles={generateCustomStyles("gender", formik)}
                    />
                    {formik.touched.gender && formik.errors.gender && (
                      <FormFeedback>{formik.errors.gender.value}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Date of Birth<span className="mandatory">*</span>
                    </Label>
                    <Flatpickr
                      className={`form-control`}
                      options={{
                        altFormat: "F j, Y",
                        dateFormat: "Y-m-d",
                        // maxDate: new Date().fp_incr(0),
                        maxDate: new Date().fp_incr(-17 * 365.25), // Restrict to 18 years or more in the past
                      }}
                      style={{
                        backgroundColor: "white", // Set background color to white
                      }}
                      name="AuditorAge"
                      value={formik.values.AuditorAge}
                      placeholder="DD-MM-YYYY"
                      // onChange={(dates) => {
                      //   // setAuditorAge(dates[0].toISOString().split('T')[0]);
                      //   formik.setFieldValue(
                      //     "AuditorAge",
                      //     dates[0].toISOString().split("T")[0]
                      //   ); // Update formik value
                      // }}
                      onChange={(dates) => {
                        if (dates?.[0]) {
                          const formattedDate = moment(dates[0]).format(
                            "YYYY-MM-DD"
                          );
                          formik.setFieldValue("AuditorAge", formattedDate);
                        } else {
                          formik.setFieldValue("AuditorAge", ""); // Handle case when date is cleared
                        }
                      }}
                    />
                    {formik.touched.AuditorAge && formik.errors.AuditorAge && (
                      <div
                        style={{
                          width: "100%",
                          marginTop: "3px",
                          fontSize: "80%",
                          color: "#dc3545",
                        }}
                      >
                        {formik.errors.AuditorAge}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col sm="6" style={{ zIndex: "3" }}>
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Preference Cities
                    </Label>
                    <CreatableSelect
                      isClearable
                      className="React"
                      classNamePrefix="Enter cities"
                      name="WorkCity"
                      isMulti
                      placeholder="Enter cities"
                      noOptionsMessage={() => "Type to create new city name"}
                      onChange={(selectedOption) => {
                        formik.setFieldValue("WorkCity", selectedOption);
                      }}
                      value={formik.values.WorkCity}
                    />
                    {formik.touched.WorkCity && formik.errors.WorkCity && (
                      <div className="error text-danger pl-2">
                        {formik.errors.WorkCity}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col sm="6" style={{ zIndex: "2" }}>
                  <FormGroup>
                    <Label htmlFor="">
                      Qualification<span className="mandatory">*</span>
                    </Label>
                    <Select
                      classNamePrefix="select"
                      name="AuditorQual"
                      onChange={(selectedOption) =>
                        formik.setFieldValue("AuditorQual", selectedOption)
                      }
                      value={formik.values.AuditorQual}
                      options={Allqualification}
                      className={`React ${formik.touched.AuditorQual && formik.errors.AuditorQual
                          ? "is-invalid"
                          : ""
                        }`}
                      styles={generateCustomStyles("AuditorQual", formik)}
                    />
                    {formik.touched.AuditorQual &&
                      formik.errors.AuditorQual && (
                        <FormFeedback>
                          {formik.errors.AuditorQual.value}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Upload Resume
                      {formik?.values?.resumeFile ? (
                        <a
                          href={
                            formik.values.resumeFile instanceof File ||
                            (typeof formik.values?.resumeFile === "object" && formik.values.resumeFile !== null)
                              ? URL.createObjectURL(formik.values.resumeFile)
                              : getFileUrl(formik.values.resumeFile || userData?.fld_resumeurl)
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          className="ml-2 text-primary"
                        >
                          ( View )
                        </a>
                      ) : (
                        " (.pdf file)"
                      )}
                    </Label>

                    <div className="d-flex align-items-center">
                      <Input
                        type="file"
                        name="resumeFile"
                        accept="application/pdf"
                        id="nameVertical"
                        style={{ flex: 1 }}
                        onChange={(e) => {
                          e.preventDefault();
                          const file = e.target.files[0];
                          formik.setFieldValue("resumeFile", file);
                          if (file && file.size > 5000000) {
                            Notiflix.Notify.failure(
                              "File too large, upload file less than 5 Mb."
                            );
                          }
                        }}
                      />
                      <Button
                        type="button"
                        onClick={() => setShowResumeModal(true)}
                        className="ml-2 text-nowrap"
                        style={{
                          backgroundColor: "#c16d18",
                          borderColor: "#c16d18",
                          color: "#ffffff",
                          fontWeight: "600",
                          fontSize: "13px",
                          padding: "6px 14px",
                          borderRadius: "4px",
                          boxShadow: "0 2px 5px rgba(0,0,0,0.15)"
                        }}
                      >
                        <FileText size={15} className="mr-1" /> Resume Builder
                      </Button>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            )}
            {step == 2 && (
              <Row>
                <Col sm="12">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Address
                      <span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="textarea"
                      className="p-3"
                      name="AuditorAddress"
                      // id="nameVertical"
                      onChange={formik.handleChange}
                      value={formik.values.AuditorAddress}
                      invalid={
                        formik.touched.AuditorAddress &&
                        !!formik.errors.AuditorAddress
                      }
                    />
                    {formik.touched.AuditorAddress &&
                      formik.errors.AuditorAddress && (
                        <FormFeedback>
                          {formik.errors.AuditorAddress}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>

                <Col sm="6" style={{ zIndex: "5" }}>
                  <FormGroup>
                    <Label htmlFor="">
                      Country<span className="mandatory">*</span>
                    </Label>
                    <Select
                      classNamePrefix="select"
                      name="AuditorCountry"
                      onChange={(selectedOption) => {
                        formik.setFieldValue("AuditorCountry", selectedOption);
                        formik.setFieldValue("AuditorState", "");
                        // formik.setFieldValue("AuditorState", allState[0]);
                        formik.setFieldValue("AuditorCity", "");
                      }}
                      options={allCountry}
                      value={formik.values.AuditorCountry}
                      className={`React ${formik.touched.AuditorCountry &&
                          formik.errors.AuditorCountry
                          ? "is-invalid"
                          : ""
                        }`}
                      styles={generateCustomStyles("AuditorCountry", formik)}
                    />
                    {formik.touched.AuditorCountry &&
                      formik.errors.AuditorCountry && (
                        <FormFeedback>
                          {formik.errors.AuditorCountry.value}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col sm="6" style={{ zIndex: "4" }}>
                  <FormGroup>
                    <Label htmlFor="">
                      State<span className="mandatory">*</span>
                    </Label>
                    <Select
                      classNamePrefix="select"
                      name="AuditorState"
                      onChange={(selectedOption) => {
                        formik.setFieldValue("AuditorState", selectedOption);
                        formik.setFieldValue("AuditorCity", "");
                      }}
                      value={formik.values.AuditorState}
                      options={allState}
                      className={`React ${formik.touched.AuditorState &&
                          formik.errors.AuditorState
                          ? "is-invalid"
                          : ""
                        }`}
                      styles={generateCustomStyles("AuditorState", formik)}
                    />
                    {formik.touched.AuditorState &&
                      formik.errors.AuditorState && (
                        <FormFeedback>
                          {formik.errors.AuditorState.value}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>

                <Col sm="6" style={{ zIndex: "3" }}>
                  <FormGroup>
                    <Label htmlFor="">
                      City<span className="mandatory">*</span>
                    </Label>
                    <Select
                      classNamePrefix="select"
                      name="AuditorCity"
                      onChange={(selectedOption) =>
                        formik.setFieldValue("AuditorCity", selectedOption)
                      }
                      options={allCity}
                      value={formik.values.AuditorCity}
                      className={`React ${formik.touched.AuditorCity && formik.errors.AuditorCity
                          ? "is-invalid"
                          : ""
                        }`}
                      styles={generateCustomStyles("AuditorCity", formik)}
                    />
                    {formik.touched.AuditorCity &&
                      formik.errors.AuditorCity && (
                        <FormFeedback>
                          {formik.errors.AuditorCity.value}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Pincode<span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="AuditorPincode"
                      id="nameVertical"
                      placeholder="Enter your Pincode"
                      maxLength={6}
                      onChange={formik.handleChange}
                      value={formik.values.AuditorPincode}
                      invalid={
                        formik.touched.AuditorPincode &&
                        !!formik.errors.AuditorPincode
                      }
                    />
                    {formik.touched.AuditorPincode &&
                      formik.errors.AuditorPincode && (
                        <FormFeedback>
                          {formik.errors.AuditorPincode}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="">
                      Where Did You Hear About Us?
                      {/* <span className="mandatory">*</span> */}
                    </Label>
                    <Input
                      type="text"
                      name="SourceName"
                      id="nameVertical"
                      placeholder="Enter Source"
                      onChange={formik.handleChange}
                      value={formik.values.SourceName}
                      invalid={
                        formik.touched.SourceName && !!formik.errors.SourceName
                      }
                    />
                    {formik.touched.SourceName && formik.errors.SourceName && (
                      <FormFeedback>{formik.errors.SourceName}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <div className="text-center">
                    <Label htmlFor="nameVertical">Experience with TRPW ?</Label>
                    <div className="d-flex justify-content-center my-2">
                      <div className="mr-5">
                        <Input
                          type="radio"
                          name="ExperienceTrpw"
                          onChange={() =>
                            formik.setFieldValue("ExperienceTrpw", 1)
                          }
                          style={{ accentColor: "#c16d18" }}
                          checked={formik.values.ExperienceTrpw == 1}
                          value={formik.values.ExperienceTrpw}
                        />
                        <span>Yes</span>
                      </div>
                      <div className="d-flex">
                        {" "}
                        <Input
                          type="radio"
                          name="ExperienceTrpw"
                          onChange={() =>
                            formik.setFieldValue("ExperienceTrpw", 0)
                          }
                          style={{ accentColor: "#c16d18" }}
                          checked={formik.values.ExperienceTrpw == 0}
                          value={formik.values.ExperienceTrpw}
                        />
                        <span>No</span>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="">Name of the Manager / Employee ID</Label>
                    <Input
                      type="text"
                      name="PreEmployeeName"
                      id="nameVertical"
                      placeholder="Name / Employee ID"
                      onChange={formik.handleChange}
                      value={formik.values.PreEmployeeName}
                      disabled={formik.values.ExperienceTrpw == 0}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}
          </CardBody>
        </Card>
        <div
          className="mx-2"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div>
            {" "}
            {step !== 1 && (
              <Button
                // disabled={step == 1 ? true : false}
                // color="secondary"
                className="cancelBtn"
                onClick={handlePrevious}
              >
                Previous
              </Button>
            )}
          </div>

          <div className="text-end">
            {step < 2 && (
              <Button
                // color="primary"
                className="btns"
                onClick={handleNext}
              >
                Next
              </Button>
            )}
          </div>
          <div>
            {step == 2 && (
              // <Col sm="6"  className="text-right">
              <Button
                // color="primary"
                className="btns"
                onClick={() => formik.handleSubmit()}
              >
                Submit
              </Button>
              // </Col>
            )}
          </div>
        </div>
        {/* <Row className="mx-2">
          <Col md="6">
            {step !== 1 && (
              <Button
                // disabled={step == 1 ? true : false}
                // color="secondary"
                className="cancelBtn"
                onClick={handlePrevious}
              >
                Previous
              </Button>
            )}
          </Col>

          <Col sm="6">
            {step < 2 && (
              <Button
                // color="primary"
                className="btns"
                onClick={handleNext}
              >
                Next
              </Button>
            )}
            {step == 2 && (
              // <Col sm="6"  className="text-right">
              <Button
                // color="primary"
                className="btns"
                onClick={() => formik.handleSubmit()}
              >
                Submit
              </Button>
              // </Col>
            )}
          </Col>
          {step == 2 && (
            <Col sm="6"  className="text-right">
              <Button
                // color="primary"
                className="btns"
                onClick={() => formik.handleSubmit()}
              >
                Submit
              </Button>
            </Col>
          )}
        </Row> */}
        <ResumeBuilderModal
          isOpen={showResumeModal}
          toggle={() => setShowResumeModal(!showResumeModal)}
          userData={userData}
          formikValues={formik.values}
          onSaveResume={(generatedFile) => {
            formik.setFieldValue("resumeFile", generatedFile);
          }}
        />
      </FormGroup>
    </div>
  );
};

export default BasicProfileContent;
